import React, { useCallback, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { CalendarDateFill } from "react-bootstrap-icons";
import { zodResolver } from "@hookform/resolvers/zod";
import { useAppDispatch, useAppSelector } from "store";
import { Button, DateInput, Icon, Select, TextInput } from "ui";
import { useTerminals } from "features/terminals/api/get-terminals";

import { transactionsFormFields, transactionsSchema } from "../../schema";
import { setInvalidateKey, setTransactionsFilter } from "../../slice";
import { terminalSelectOption } from "../../utils";

export const TransactionsForm = ({ isLoading }: { isLoading?: boolean }) => {
  const dispatch = useAppDispatch();
  const terminalQuery = useTerminals({
    PageNumber: 1,
    PageSize: 10000,
  });
  const terminals = terminalQuery.data?.data;
  const terminalsOptions = terminalSelectOption(terminals);
  const { transactionFilter } = useAppSelector((state) => state.transactions);
  const form = useForm<transactionsFormFields>({
    resolver: zodResolver(transactionsSchema),
    defaultValues: {
      startDate: transactionFilter?.startDate,
      endDate: transactionFilter?.endDate,
    },
  });
  const { handleSubmit, control, reset, register } = form;
  const resetFormHandler = useCallback(() => {
    if (terminals) {
      reset({
        terminalId: {
          value: terminals[0].id,
          label: terminals[0].terminalNumber,
        },
        startDate: new Date(),
        endDate: new Date(),
        BuyId: "",
        TrackingNumber: "",
      });
      dispatch(
        setTransactionsFilter({
          terminalId: terminals[0].id,
          startDate: new Date(),
          endDate: new Date(),
          BuyId: undefined,
          TrackingNumber: undefined,
        })
      );
    }
  }, [dispatch, reset, terminals]);
  useEffect(() => {
    resetFormHandler();
  }, [resetFormHandler]);
  const submitHandler: SubmitHandler<transactionsFormFields> = (
    values: transactionsFormFields
  ) => {
    dispatch(
      setTransactionsFilter({
        startDate: values.startDate,
        endDate: values.endDate,
        terminalId: values.terminalId.value,
        BuyId: values.BuyId,
        TrackingNumber: values.TrackingNumber,
      })
    );
    dispatch(setInvalidateKey(new Date()));
  };
  return (
    <form
      onSubmit={handleSubmit(submitHandler)}
      className={"d-flex justify-content-between gap-1 align-center flex-wrap"}
    >
      <DateInput
        icon={<CalendarDateFill />}
        isHorizontal
        name="startDate"
        controller={control}
        label={"از تاریخ :"}
      />
      <DateInput
        icon={<CalendarDateFill />}
        isHorizontal
        name="endDate"
        controller={control}
        label={"تا تاریخ :"}
      />

      <TextInput
        isHorizontal
        registration={register("BuyId")}
        placeholder="کد خرید را وارد کنید"
        label={"کد خرید:"}
      />
      <TextInput
        isHorizontal
        registration={register("TrackingNumber")}
        placeholder="کد رهگیری را وارد کنید"
        label={"کد رهگیری:"}
      />
      <Select
        icon={<Icon type="terminals" />}
        isHorizontal
        isLoading={terminalQuery.isFetching}
        isRequired
        options={terminalsOptions}
        name="terminalId"
        controller={control}
        label={"ترمینال :"}
        placeholder={"ترمینال مورد نظر را انتخاب کنید"}
      />
      <div className="my-3 w-100 d-flex flex-row-reverse gap-2">
        <Button
          isLoading={isLoading}
          isDisabled={isLoading}
          type="submit"
          onClick={handleSubmit(submitHandler)}
        >
          اعمال فیلتر
        </Button>
        <Button
          type="button"
          variant="info_outline"
          onClick={() => {
            resetFormHandler();
          }}
        >
          پاکسازی
        </Button>
      </div>
    </form>
  );
};
